/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Ref_N6Inputs */

const en_diff_ref_n6 = /** @type {(inputs: Diff_Ref_N6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Used when the two top level values differ in type, such as an object against an array.`)
};

const ko_diff_ref_n6 = /** @type {(inputs: Diff_Ref_N6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최상위 두 값의 타입이 다를 때 쓰입니다. 객체와 배열을 비교하는 경우가 그렇습니다.`)
};

const ja_diff_ref_n6 = /** @type {(inputs: Diff_Ref_N6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最上位の 2 つの値の型が異なるときに使われます。オブジェクトと配列を比べる場合などです。`)
};

/**
* | output |
* | --- |
* | "Used when the two top level values differ in type, such as an object against an array." |
*
* @param {Diff_Ref_N6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_ref_n6 = /** @type {((inputs?: Diff_Ref_N6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Ref_N6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_ref_n6(inputs)
	if (locale === "ko") return ko_diff_ref_n6(inputs)
	return ja_diff_ref_n6(inputs)
});